/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import PendingRequestBox from "../../../../common/components/PendingRequestBox";
import PendingRequestInterface from "../../../../infra/aggregates/PendingRequestsInterface";
import CustomDashboardCard from "../../../../common/components/CustomDashboardCard/CustomDashboardCard";
import Loader from "../../../../common/Lottifiers/Loader/Loader";

interface PendingRequestsProps {
  requests: PendingRequestInterface[];
  isLoading?: boolean;
  trans?: any;
}

const PendingRequest = ({
  requests,
  isLoading,
  trans,
}: PendingRequestsProps) => {
  return (
    <>
      <CustomDashboardCard cardSize={{ card_title: trans("Pending Request") }}>
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <PendingRequestBox requests={requests} />
        )}
      </CustomDashboardCard>
    </>
  );
};

export default PendingRequest;
